module.exports = __webpack_public_path__ + "static/media/filestack-logo.3082f1bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/filestack-logo.png
// module id = 160
// module chunks = 0